module.exports = __webpack_public_path__ + "img/cliente3.4ca06be6.png";